import "bootstrap-icons/font/bootstrap-icons.css";

import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { eligibility } from "constants/eligibility";
import { handleOpenPdf } from "utils";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import pds from "assets/pdf/cards/Product-Disclosure-Sheet-Rafahia-Debit-Card-i.pdf";
import form from "assets/pdf/cards/Rafahia-Application-Form-v2.11.pdf";
import rahafia from "assets/images/rahafia_table.svg";
import outline_check from "assets/images/outline_check.svg";
import Cards from "assets/images/hero-images/Banner_Cards.png";
import BG from "assets/images/hero-images/BG.png";

function Rafahia() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Cards"
          title={` <span className="jumbotron-subtitle-2">
                Rafahia
              </span>
              Debit Card-<i>i </i><br>Protection and Privileges for
              <span className="jumbotron-subtitle-2">
                your pilgrimage journey
              </span>`}
          buttonText="Talk to us"
          backgroundImage={Cards}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Rafahia Debit Card-i is complete with its own unique benefits,
              unparalleled to any other debit card currently available. The
              card's Takaful protection and exclusive alrajhi bank Malaysia
              banking privileges is specifically designed for your pilgrimage
              journey to Hajj and Umrah. Leave your worries and safety with us
              so that you can focus on performing your spiritual journey. 
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Worldwide</div>
                <div className="column-subheader-2">
                  Protection up to RM350,000 all year round{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Ujrah contract</div>
                <div className="column-subheader-2">
                  Based on Shariah contract of ‘Ujrah’
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah standards</div>
                <div className="column-subheader-2">
                  Compliance with alrajhi bank Malaysia Shariah standards{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Emergency evacuation</div>
                <div className="column-subheader-2">
                  Emergency evacuation and supervised repatriation up to
                  RM40,000{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Additional Protection</div>
                <div className="column-subheader-2">
                  Up to RM700,000 during Umrah & Hajj or while travelling in any
                  public transport systems
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Privileges</div>
                <div className="column-subheader-2">
                  Exclusive alrajhi bank Malaysia banking privileges
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilityrahafia.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={rahafia}
              className="d-inline-block align-top"
              alt=""
            />

            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <LinkButton
                text="e-Application Form"
                onClick={() => handleOpenPdf(form)}
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pds)}
              />
            </div>
            <p style={{ paddingTop: "40px" }}>
              The Shariah Board of Al-Rajhi Bank does not review or recommend
              any of Takaful operators including their products and other
              related agreements. The Shariah compliance status of Takaful
              products is at the responsibility of their respective Shariah
              Committee.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Rafahia;
